import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=f8efde10&scoped=true&"
import script from "./SearchView.vue?vue&type=script&lang=js&"
export * from "./SearchView.vue?vue&type=script&lang=js&"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=f8efde10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8efde10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8efde10')) {
      api.createRecord('f8efde10', component.options)
    } else {
      api.reload('f8efde10', component.options)
    }
    module.hot.accept("./SearchView.vue?vue&type=template&id=f8efde10&scoped=true&", function () {
      api.rerender('f8efde10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchView.vue"
export default component.exports